(() => {
  const revealSelector = '[data-jc-reveal]';
  const itemSelector = '[data-jc-reveal-item]';
  const registrations = new Map();

  function motionIsDisabled() {
    return (
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
      || navigator.connection?.saveData
      || !('IntersectionObserver' in window)
    );
  }

  function collectRevealNodes(root) {
    const nodes = [];
    if (root instanceof Element && root.matches(revealSelector)) {
      nodes.push(root);
    }
    if (typeof root.querySelectorAll === 'function') {
      nodes.push(...root.querySelectorAll(revealSelector));
    }
    return nodes;
  }

  function rootContains(root, node) {
    return root === document || root === node || (typeof root.contains === 'function' && root.contains(node));
  }

  function showRevealNodes(root) {
    for (const node of collectRevealNodes(root)) {
      node.classList.add('is-jc-visible');
    }
  }

  function destroy(root = document) {
    for (const [registrationRoot, registration] of registrations) {
      let removedNode = false;
      for (const node of registration.nodes) {
        if (!rootContains(root, node)) continue;
        removedNode = true;
        registration.observer.unobserve(node);
        registration.nodes.delete(node);
        node.classList.add('is-jc-visible');
      }

      if (removedNode && typeof registration.observer.takeRecords === 'function') {
        registration.observer.takeRecords();
      }

      if (registrationRoot === root || registration.nodes.size === 0) {
        registration.observer.disconnect();
        registrations.delete(registrationRoot);
      }
    }

    if (root === document) {
      document.documentElement.classList.remove('jc-motion-ready');
    }
  }

  function init(root = document) {
    if (motionIsDisabled()) {
      destroy(document);
      showRevealNodes(document);
      if (root !== document) showRevealNodes(root);
      return;
    }

    destroy(root);
    const nodes = collectRevealNodes(root);
    if (nodes.length === 0) return;

    document.documentElement.classList.add('jc-motion-ready');

    for (const node of nodes) {
      node.classList.remove('is-jc-visible');
      node.querySelectorAll(itemSelector).forEach((item, index) => {
        item.style.setProperty('--jc-reveal-index', index);
      });
    }

    const registration = { nodes: new Set(nodes), observer: null };
    const observer = new IntersectionObserver((entries, currentObserver) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('is-jc-visible');
        currentObserver.unobserve(entry.target);
        registration.nodes.delete(entry.target);
      }

      if (registration.nodes.size === 0) {
        currentObserver.disconnect();
        if (registrations.get(root) === registration) {
          registrations.delete(root);
        }
      }
    }, { threshold: 0.16 });

    registration.observer = observer;
    registrations.set(root, registration);
    nodes.forEach((node) => observer.observe(node));
  }

  window.JungleCallingMotion = Object.freeze({ init, destroy });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => destroy(event.target));
})();
